import gql from 'graphql-tag';

export default gql`
mutation($isButtonDisabled: Boolean!) {
  setButtonsDisabledOnAutosave(isButtonsDisabledOnAutosave: $isButtonDisabled) @client
}
`;
